import { organizationEndpoints } from '../../services/api/endpoints/organisation.endpoint';

export const orgIngestStatusLongPolling = async (orgId: string): Promise<boolean> => {
  // Return a new Promise
  return new Promise((resolve, reject) => {
    const interval = setInterval(async () => {
      try {
        const statusResponse = await organizationEndpoints.getSingleOrganisation(orgId);
        console.log('Polling for ingest status:', statusResponse);
        const orgStatus = statusResponse?.ingest_status;
        if (orgStatus === 'completed') {
          clearInterval(interval);
          resolve(true);
        }
        if (orgStatus !== 'started') {
          clearInterval(interval);
          reject(false);
        }
      } catch (error) {
        reject(error);
      }
    }, 10000);
  });
};
